













import {Component, Mixins, Prop, Ref, Watch} from 'vue-property-decorator'
import {Portal} from '@linusborg/vue-simple-portal'
import MonitorMixin from "@/design-system/utilities/MonitorMixin"

/**
 * This is meant for simple tooltips, with no handling for click-outside-to-close or width controls.
 */
@Component({
    components: {SimplePortal: Portal}
})
export default class JdhSneakPeek extends Mixins(MonitorMixin) {

    @Prop({default: 'auto'}) position!: 'auto'|'right'
    @Prop({default: false, type: Boolean}) visible!: boolean
    @Prop() anchor!: HTMLElement
    @Ref() popupEl!: HTMLElement
    @Ref() innerEl!: HTMLElement

    // TODO: implement a way to automatically attach listeners
    autoVisible = false
    raf: number|null = null

    get isVisible() {
        return this.visible || this.autoVisible
    }

    @Watch('isVisible')
    syncListeners() {
        if (this.isVisible) {
            document.addEventListener('scroll', this.updatePosition, {
                capture: true,
                passive: true,
            })
            window.addEventListener('resize', this.updatePosition, {
                capture: true,
                passive: true,
            })
        } else {
            document.removeEventListener('scroll', this.updatePosition)
            window.removeEventListener('resize', this.updatePosition)
        }
    }

    @Watch('isVisible')
    attachToAnchor() {
        if (this.isVisible) {
            if (!this.anchor) {
                this.$warn('No anchor available, popup is unable to position itself.', 'NO_ANCHOR')
                return
            }

            this.updatePosition()
            requestAnimationFrame(() => {
                this.$emit('opened')
            })
        }
    }

    updatePosition() {
        if (this.raf) return

        this.raf = requestAnimationFrame(this.renderPosition)
    }

    renderPosition() {
        if (!this.anchor || !this.popupEl) {
            // this function may be called after these elements have disappeared due to the animation frame buffering.
            this.raf = null
            return
        }

        const anchorBox = this.anchor.getBoundingClientRect()
        const popupBox = this.popupEl.getBoundingClientRect()
        const screenBox = { width: window.innerWidth, height: window.innerHeight }
        let x, y
        if (this.position === 'right' && screenBox.width > (anchorBox.right+popupBox.width)) {
            x = anchorBox.right
            y = anchorBox.top + (anchorBox.height / 2) - (popupBox.height / 2)
        } else {
            if (screenBox.width < anchorBox.x + popupBox.width + 20) {
                // if we're at risk of right overflow, align right edges
                x = anchorBox.right - popupBox.width
            } else if (anchorBox.x - (popupBox.width / 2) < 0) {
                // if we're at risk of left overflow, align left edges
                x = anchorBox.x
            } else {
                // otherwise, align center
                x = (anchorBox.x + (anchorBox.width / 2)) - (popupBox.width / 2)
            }

            if (popupBox.height > screenBox.height - (anchorBox.top + anchorBox.height)) {
                // flip upwards, as it'll clip the bottom otherwise
                y = anchorBox.top - popupBox.height
            } else {
                y = anchorBox.top + anchorBox.height
            }
        }

        this.popupEl.style.transform = `translate3d(${x}px, ${y}px, 0px)`
        this.raf = null
    }
}
